<div
  class="stats"
  [ngStyle]="{ 'height': height }">
  <div class="global-stats">
    <div
      class="stats-box"
      fxFlex="20">
      <div
        class="data"
        fxLayout="row"
        fxLayoutAlign="center center">
        <div class="time-display">
          <div>{{ sendStartTime }}</div>
          @if (sendStartElappsedTime) {
            <div
              class="sub-title">
              {{ sendStartElappsedTime }}
            </div>
          }
        </div>
      </div>
      <div class="title">{{ 'COMMUNICATIONS.START-SEND-TIME' | translate }}</div>
    </div>
    <div
      class="stats-box"
      fxFlex="10">
      <div
        class="data"
        fxLayout="row"
        fxLayoutAlign="center center">
        <div class="total-display">{{ totalRecipients }}</div>
      </div>
      <div class="title">
        {{ 'COMMUNICATIONS.RECIPIENTS' | translate }}
      </div>
    </div>
    <div
      class="stats-box"
      fxFlex>
      <div
        class="data"
        fxLayout="row"
        fxLayoutAlign="center center"
        fxLayoutGap="16px">
        @for (stat of notificationStats?.channelStats; track stat.channelUId) {
          <div>
            <div>
              <div>
                <i
                  class="channel-icon icon {{ getChannelIcon(stat) }}"
                [title]="getChannelName(stat)"></i>
              </div>
              <div class="channel-sub-title">{{ stat.startedNumber }}</div>
            </div>
          </div>
        }
      </div>
      <div class="title">{{ 'COMMUNICATIONS.CHANNELS-CONTACTS' | translate }}</div>
    </div>
    <div
      class="stats-box"
      fxFlex="20">
      <div
        class="data"
        fxLayout="row"
        fxLayoutAlign="center center">
        <div class="time-display">
          <div>{{ sendEndTime }}</div>
          @if (sendEndElappsedTime) {
            <div
              class="sub-title">
              {{ sendEndElappsedTime }}
            </div>
          }
        </div>
      </div>
      <div class="title">{{ 'COMMUNICATIONS.FINISH-SEND-TIME' | translate }}</div>
    </div>
  </div>

  <div class="channel-stats">
    <div
      class="main-title"
      fxLayout="row"
      fxLayoutAlign="space-between center">
      <div>{{ 'COMMUNICATIONS.NOTIFICATION-QUEUE' | translate }}</div>
      <div
        fxLayout="row"
        fxLayoutAlign="start center">
        @for (action of navigationActions; track action.action.uId) {
          <div>
            @if (action.style === 'pause') {
              <button
                class="button is-secondary ml-4"
                (click)="onNavigateToAction(action)">
                <i class="icon button-icon icon-small_pause"></i>
                {{ action.name }}
              </button>
            }
            @if (action.style === 'resume') {
              <button
                class="button is-secondary ml-4"
                (click)="onNavigateToAction(action)">
                <i class="icon button-icon icon-small_play"></i>
                {{ action.name }}
              </button>
            }
            @if (action.style === 'complete') {
              <button
                class="button is-secondary ml-4"
                (click)="onNavigateToAction(action)">
                <i class="icon button-icon icon-flag_solid"></i>
                {{ action.name }}
              </button>
            }
            @if (!action.style) {
              <button
                class="button is-secondary ml-4"
                (click)="onNavigateToAction(action)">
                {{ action.name }}
              </button>
            }
          </div>
        }
      </div>
    </div>
    <div class="stat-bars">
      <div
        class="main-stat-bars"
        [ngClass]="{ 'collapsed': !statsExpanded }"
        (click)="expandCollapseStats()">
        <div
          class="header"
          fxLayout="row"
          fxLayoutAlign="space-between center">
          <div
            fxLayout="row"
            fxLayoutAlign="start center">
            <div
              class="expand-collapse"
              title="{{ 'COMMUNICATIONS.EXPAND-COLLAPSE' | translate }}">
              <i class="icon {{ statsExpanded ? 'icon-caret_medium_up' : 'icon-caret_medium_right' }}"></i>
            </div>
            <div class="delivery-attempt-message">
              {{ globalAttemptMessage }}
            </div>
          </div>
          <div class="delivered-message">
            {{ globalDeliveryMessage }}
          </div>
        </div>

        <div>
          <div class="main-stat-bar">
            @for (statCount of rollUpStatusCounts; track statCount.status; let i = $index) {
              <span>
                <span
                  class="main-stat-bar-item"
                  [ngClass]="{ 'first': i === 0, 'last': i === rollUpStatusCounts.length - 1 }"
                  [title]="getRollupStatusDispTitle(statCount)"
                [ngStyle]="{
                  'width': (statCount.count * 100) / totalRollupCount + '%',
                  'background-color': getStatusColor(statCount.status)
                }"></span>
              </span>
            }
          </div>
        </div>
      </div>

      @if (statsExpanded) {
        <div
          class="sec-stat-bars"
          >
          @for (stat of notificationStats?.channelStats; track stat.channelUId) {
            <div>
              @if (stat.totalRecipientCount) {
                <div>
                  <div
                    class="header"
                    fxLayout="row"
                    fxLayoutAlign="space-between center">
                    <div
                      fxLayout="row"
                      fxLayoutAlign="start center">
                      <i
                        class="channel-icon icon {{ getChannelIcon(stat) }}"
                      [title]="getChannelName(stat)"></i>
                      <div class="delivery-attempt-message">
                        {{ stat.attemptMessage }}
                      </div>
                    </div>
                    <div class="delivered-message">
                      {{ stat.deliveryMessage }}
                    </div>
                  </div>
                  @if (stat.totalRecipientCount) {
                    <div>
                      <div class="stat-bar">
                        @for (statCount of getNonEmptyStatusCounts(stat); track statCount.status; let i = $index) {
                          <span>
                            <span
                              class="stat-bar-item"
                              [ngClass]="{ 'first': i === 0, 'last': i === getNonEmptyStatusCounts(stat).length - 1 }"
                              [title]="getStatusDispTitle(statCount)"
                    [ngStyle]="{
                      'width': (statCount.count * 100) / stat.totalRecipientCount + '%',
                      'background-color': getStatusColor(statCount.status)
                    }"></span>
                          </span>
                        }
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          }
        </div>
      }
    </div>

    <div
      class="legend"
      fxLayout="row"
      fxLayoutAlign="center center">
      @for (item of statsLegend; track item; let i = $index) {
        <div>
          <div
            class="legend-item"
            fxLayout="row"
            fxLayoutAlign="center center">
            <div
              class="color"
            [ngStyle]="{ 'background-color': getStatusColor(item) }"></div>
            <div class="title">
              {{ getStatusLegendTitle(item) }}
            </div>
          </div>
        </div>
      }
    </div>
  </div>
  <div
    fxLayout="row"
    fxLayoutAlign="center center">
    <topo-comms-notification-responses-over-time-chart-widget
      [width]="barWidth"
      [notification]="_notification"
    [notificationStats]="notificationStats"></topo-comms-notification-responses-over-time-chart-widget>
  </div>
  <div
    fxLayout="row"
    fxLayoutAlign="center center">
    <topo-notification-delivery-status-chart-widget
      [width]="chartWidth"
      [notification]="_notification"
      [template]="template"
      [totalRecipients]="totalRecipients"
    [notificationStats]="notificationStats"></topo-notification-delivery-status-chart-widget>
    <topo-notification-response-status-chart-widget
      [width]="chartWidth"
      [notification]="_notification"
      [template]="template"
      [totalRecipients]="totalRecipients"
    [notificationStats]="notificationStats"></topo-notification-response-status-chart-widget>
  </div>
</div>

<topo-confirm
  [isActive]="showConfirmValidation"
  (respond)="onConfirmValidation($event)"
  title="{{ 'COMMUNICATIONS.CONFIRM-NOTIFICATION-WORKFLOW-NAVIGATION-TITLE' | translate }}"
  [message]="confirmationMessage"
  yesText="{{ 'COMMUNICATIONS.CONFIRM-YES' | translate }}"
  noText="{{ 'COMMUNICATIONS.CONFIRM-NO' | translate }}"
icon="icon-workflow"></topo-confirm>
